import React, { Component } from 'react';
import './Hotspot.css';
import stopEventPropagation from '../ui_core/stopEventPropagation';
import ParameterErrors from '../errors/ParameterErrors';
const{throwNotProvided, throwNotOfType}=ParameterErrors;
export default class Hotspot{
	constructor(props){
		const self = this;
		const {scene360Hotspot, scene360, marzipanoScene, getIconUrlFromRelativePath, onClick}=props;
		this._scene360Hotspot = scene360Hotspot;
		this._scene360 = scene360;
		this._callbackClick = onClick;
		this._iconUrl = getIconUrlFromRelativePath(scene360Hotspot.iconRelativePath);
		this._eulerAngles = scene360Hotspot.eulerAngles;
		this._pointingAtEulerAngles = scene360Hotspot.pointingAtEulerAngles;
		const rotateToCompensate = scene360Hotspot.rotateToCompensate;
		if(rotateToCompensate&&(!this._pointingAtEulerAngles))
			throwNotProvided('pointingAtEulerAngles');
		const rotation = this._eulerAngles.rollRadians;
		this._handleClick= this._handleClick.bind(this);
		this._setTransform= this._setTransform.bind(this);
		this._handleClick = this._handleClick.bind(this);
		this._calculateCompensatedRotation= this._calculateCompensatedRotation.bind(this);
		this._setToRotate= this._setToRotate.bind(this);
		const element = document.createElement('div');
		element.classList.add("hotspot");
		if(scene360Hotspot.className)
			element.classList.add(scene360Hotspot.className);
		
		const iconElement = document.createElement('img');
		iconElement.classList.add("icon");
		iconElement.classList.add("hotspot-icon");
		iconElement.addEventListener('click', this._handleClick);
		iconElement.src = this._iconUrl;
		this._iconElement = iconElement;
		
		const tooltipElement = document.createElement('div');
		tooltipElement.classList.add("hotspot-tooltip");
		tooltipElement.classList.add("hotspot-tooltip");
		//tooltipElement.innerHTML = target;
		
		element.appendChild(iconElement);
		element.appendChild(tooltipElement);
		
		this._element = element;
		
		stopEventPropagation(this._element);
		this._cosPitchRadians = Math.cos(this._eulerAngles.pitchRadians);
		this._hotspot = marzipanoScene.hotspotContainer().createHotspot(element, { yaw: this._eulerAngles.yawRadians, pitch:this._eulerAngles.pitchRadians});
		this._setTransform(rotateToCompensate?this._calculateCompensatedRotation():this._eulerAngles.roll);
		if(rotateToCompensate){
			this._setToRotate();
		}
	}
	get centerPosition(){
		const rect = this._element.getBoundingClientRect();
		return [rect.left+(this._element.offsetWidth/2), rect.top+(this._element.offsetHeight/2)];
	}
	get scene360Hotspot(){
		return this._scene360Hotspot;
	}
	get scene360(){
		return this._scene360;
	}
	get element(){
		return this._element;
	}
	_setToRotate(){
		const self = this;
		const originalUpdate = this._hotspot._update.bind(this._hotspot);
		const pointingAtEulerAngles=this._pointingAtEulerAngles;
		this._hotspot._update = function(){
			const xYMarker = this._position;
			const xYPointingAt = this._view.coordinatesToScreen({yaw:pointingAtEulerAngles.yawRadians,
				pitch:pointingAtEulerAngles.pitchRadians});			
			if(xYMarker===null)return;
			if(xYPointingAt==null||xYPointingAt.x===null||xYPointingAt.y===null)return;
			const angleRadians = (Math.PI/2) +Math.atan2((xYPointingAt.y - xYMarker.y), (xYPointingAt.x - xYMarker.x));
			self._setTransform(angleRadians);
			originalUpdate();
		};
	}
	_calculateCompensatedRotation(){
		//const a = Math.sin( this._eulerAngles.pitchRadians);
		return this._eulerAngles.rollRadians-(this._hotspot._view._yaw);
	}
	_setTransform(rotationRadians){
		var transformProperties = [ '-ms-transform', '-webkit-transform', 'transform' ];
		for (var i = 0; i < transformProperties.length; i++) {
			var property = transformProperties[i];
			this._iconElement.style[property] = 'rotate(' + rotationRadians + 'rad)';
		}
	}
	_handleClick(){
		this._callbackClick(this);
	}
}
